/* =========================================================
   Flex Wear — theme.js
   Cart drawer, AJAX add-to-cart, variant picker, mobile filters.
   Vanilla JS, no dependencies. Degrades gracefully without JS.
   ========================================================= */
(function () {
  'use strict';

  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');

  function openDrawer() { if (drawer) { drawer.classList.add('open'); document.body.style.overflow = 'hidden'; } }
  function closeDrawer() { if (drawer) { drawer.classList.remove('open'); document.body.style.overflow = ''; } }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      // Only hijack when JS cart is available; otherwise let the link go to /cart
      if (drawer) { e.preventDefault(); refreshCart().then(openDrawer); }
    }
    if (e.target.closest('[data-cart-close]') || e.target.classList.contains('cart-drawer-overlay')) {
      closeDrawer();
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Cart count + drawer refresh ---------- */
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = count; });
  }

  function refreshCart() {
    return fetch(root + '?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (drawer && data['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = data['cart-drawer'];
          var fresh = tmp.querySelector('[data-cart-drawer-inner]');
          var current = drawer.querySelector('[data-cart-drawer-inner]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
        }
        return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } });
      })
      .then(function (r) { return r ? r.json() : null; })
      .then(function (cart) { if (cart) updateCount(cart.item_count); })
      .catch(function () {});
  }

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"], form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    var original = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(function () { openDrawer(); })
      .catch(function () {})
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
  });

  /* ---------- Change / remove line items (cart page + drawer) ---------- */
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('[data-cart-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(rm.getAttribute('data-cart-remove'), 0);
    }
  });

  function changeLine(key, qty) {
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCount(cart.item_count);
        // On the cart page, reload to reflect totals; in drawer, refresh drawer.
        if (document.querySelector('[data-cart-page]')) { window.location.reload(); }
        else { refreshCart(); }
      })
      .catch(function () {});
  }

  /* ---------- Product: gallery thumbs ---------- */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    var main = document.querySelector('[data-main-image]');
    if (main) main.src = thumb.getAttribute('data-thumb');
    document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  });

  /* ---------- Product: variant picker ---------- */
  var variantData = document.querySelector('[data-variants-json]');
  if (variantData) {
    var variants = JSON.parse(variantData.textContent);
    var form = document.querySelector('[data-product-form]');
    var selected = {};

    // Seed current selection from the option marked active in each GROUP only.
    document.querySelectorAll('.variant-group[data-option-index]').forEach(function (group) {
      var idx = group.getAttribute('data-option-index');
      var active = group.querySelector('[data-value].active');
      if (active) selected[idx] = active.getAttribute('data-value');
    });

    function chooseOption(opt) {
      // The clicked swatch/chip only carries data-value; its option index
      // lives on the parent .variant-group — look it up there.
      var group = opt.closest('.variant-group[data-option-index]');
      if (!group) return;
      var idx = group.getAttribute('data-option-index');
      // Clear siblings WITHIN this group, then activate the clicked one.
      group.querySelectorAll('[data-value]').forEach(function (o) { o.classList.remove('active'); });
      opt.classList.add('active');
      selected[idx] = opt.getAttribute('data-value');
      var lbl = group.querySelector('[data-selected-label]');
      if (lbl) lbl.textContent = opt.getAttribute('data-value');
      resolveVariant();
    }

    document.addEventListener('click', function (e) {
      var opt = e.target.closest('.variant-group [data-value]');
      if (!opt) return;
      chooseOption(opt);
    });

    // Keyboard support for the role="button" swatches/chips.
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      var opt = e.target.closest('.variant-group [data-value]');
      if (!opt) return;
      e.preventDefault();
      chooseOption(opt);
    });

    function resolveVariant() {
      var match = variants.find(function (v) {
        return Object.keys(selected).every(function (i) { return v.options[i] === selected[i]; });
      });
      var idInput = form ? form.querySelector('[name="id"]') : null;
      var priceEl = document.querySelector('[data-product-price]');
      var btn = form ? form.querySelector('[type="submit"]') : null;
      if (match) {
        if (idInput) idInput.value = match.id;
        if (priceEl && match.price != null) priceEl.textContent = formatMoney(match.price);
        if (btn) {
          btn.disabled = !match.available;
          btn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
        var sPrice = document.querySelector('[data-sticky-price]');
        var sBtn = document.querySelector('[data-sticky-add]');
        if (sPrice && match.price != null) sPrice.textContent = formatMoney(match.price);
        if (sBtn) {
          sBtn.disabled = !match.available;
          sBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
        }
        swapVariantImage(match);
      } else if (btn) {
        btn.disabled = true; btn.textContent = 'Unavailable';
      }
    }

    // Swap the main gallery image to the selected variant's image (e.g. colour).
    function swapVariantImage(match) {
      var img = match.featured_image;
      if (!img || !img.src) return;
      var main = document.querySelector('[data-main-image]');
      if (!main) return;
      var src = img.src;
      // Request a sensible render width from the Shopify CDN.
      src = src.indexOf('?') === -1 ? src + '?width=900' : src + '&width=900';
      main.src = src;
      if (img.alt) main.alt = img.alt;
      // Sync the active thumbnail if one matches this variant image.
      var pos = img.position;
      document.querySelectorAll('[data-thumb]').forEach(function (t, i) {
        var isMatch = pos ? (i === pos - 1) : false;
        t.classList.toggle('active', isMatch);
      });
    }

    function formatMoney(cents) {
      var wrap = document.querySelector('[data-product-price-wrap]');
      var cur = wrap && wrap.getAttribute('data-currency');
      if (cur && window.Intl && Intl.NumberFormat) {
        try {
          return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(cents / 100);
        } catch (e) {}
      }
      return '£' + (cents / 100).toFixed(2);
    }
  }

  /* ---------- Product: sticky add-to-cart bar ---------- */
  (function () {
    var bar = document.querySelector('[data-sticky-atc]');
    var pform = document.querySelector('[data-product-form]');
    if (!bar || !pform) return;
    var mainBtn = pform.querySelector('[type="submit"]');
    if (!mainBtn) return;

    var sBtn = bar.querySelector('[data-sticky-add]');
    if (sBtn) sBtn.addEventListener('click', function () {
      if (pform.requestSubmit) pform.requestSubmit(); else pform.submit();
    });

    // Reveal the bar only once the main button has scrolled out of view.
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.hidden = en.isIntersecting; });
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(mainBtn);
    }
  })();

  /* ---------- Product: size guide modal ---------- */
  (function () {
    var modal = document.querySelector('[data-size-guide]');
    if (!modal) return;
    function open() { modal.hidden = false; document.body.style.overflow = 'hidden'; }
    function close() { modal.hidden = true; document.body.style.overflow = ''; }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-size-guide-open]')) { e.preventDefault(); open(); }
      else if (e.target.closest('[data-size-guide-close]')) { e.preventDefault(); close(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  })();

  /* ---------- Product: quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentNode.querySelector('input');
    var val = parseInt(input.value, 10) || 1;
    val += parseInt(step.getAttribute('data-qty-step'), 10);
    input.value = Math.max(1, val);
  });

  /* ---------- Collection: mobile filters ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-filters-open]')) {
      document.querySelector('.filters').classList.add('open');
      document.body.style.overflow = 'hidden';
    }
    if (e.target.closest('[data-filters-close]')) {
      document.querySelector('.filters').classList.remove('open');
      document.body.style.overflow = '';
    }
  });

  /* Auto-submit facet form on change (progressive enhancement) */
  var facetForm = document.querySelector('[data-facet-form]');
  if (facetForm) {
    facetForm.addEventListener('change', function () { facetForm.submit(); });
  }
})();
